(function () {
  if (!document.body.classList.contains("drop-coor-theme")) return;

  /* Home — lock one viewport, no scroll (desktop + mobile) */
  if (document.body.classList.contains("template-index")) {
    document.documentElement.classList.add("drop-no-scroll");
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    document.documentElement.style.height = "100%";
    document.body.style.height = "100%";
    document.documentElement.style.touchAction = "manipulation";
    document.body.style.touchAction = "manipulation";
    document.addEventListener(
      "touchmove",
      function (e) {
        var el = e.target;
        while (el && el !== document.body) {
          if (
            el.closest &&
            el.closest(
              ".drop-shop-details, .drawer-menu, .drawer-menu__panel, .mobile-nav, .quick-cart, .cart-flyout, [role='dialog']"
            )
          ) {
            return;
          }
          el = el.parentElement;
        }
        e.preventDefault();
      },
      { passive: false }
    );
  }

  var LABEL_MAP = {
    store: "SHOP",
    shop: "SHOP",
    home: "HOME",
    archive: "LOOKBOOK",
    lookbook: "LOOKBOOK",
  };

  var SHOP_LINKS = [
    { label: "SHOP ALL", href: "/collections/all" },
    { label: "ACCESSORIES", href: "/collections/accessories" },
    { label: "BOTTOMS", href: "/collections/bottoms" },
    { label: "TOPS", href: "/collections/tops" },
  ];
  /* Desktop: SHOP dropdown. LOCATION is a plain header link (like LOOKBOOK). */

  function remapLabel(el) {
    if (!el) return;
    var raw = (el.textContent || "").trim().toLowerCase();
    if (!LABEL_MAP[raw]) return;
    var hasKids = el.children && el.children.length;
    if (hasKids) {
      var textNode = null;
      el.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && n.textContent.trim()) textNode = n;
      });
      if (textNode) textNode.textContent = LABEL_MAP[raw];
      else el.insertBefore(document.createTextNode(LABEL_MAP[raw] + " "), el.firstChild);
    } else {
      el.textContent = LABEL_MAP[raw];
    }
  }

  document
    .querySelectorAll(
      ".dette-er-nav-menyen .nav--depth-1 > .nav__item > .nav__link, .dette-er-nav-menyen .nav--depth-1 > .nav__item > .nav__link-parent, .drawer-menu__primary-links > .drawer-menu__item > .drawer-menu__link"
    )
    .forEach(function (el) {
      var span = el.querySelector("span:not(.arrow):not(.icon)");
      remapLabel(span || el);
    });

  var topNav = document.querySelector(".dette-er-nav-menyen .nav--depth-1:not(.nav__submenu)");
  if (topNav) {
    var hasHome = [...topNav.querySelectorAll(":scope > .nav__item > a")].some(function (a) {
      var t = (a.textContent || "").trim().toLowerCase();
      return t === "home" || a.getAttribute("href") === "/" || a.getAttribute("href") === "";
    });
    if (!hasHome) {
      var li = document.createElement("li");
      li.className = "nav__item";
      li.innerHTML = '<a href="/" class="nav__link">HOME</a>';
      topNav.insertBefore(li, topNav.firstChild);
    }

    [...topNav.querySelectorAll(":scope > .nav__item")].forEach(function (item) {
      var a = item.querySelector(":scope > a");
      if (a && (a.textContent || "").trim().toUpperCase() === "HELP") item.remove();
    });
  }

  document.querySelectorAll(".cart-text").forEach(function (el) {
    el.textContent = "CART";
  });
  document.querySelectorAll(".quick-cart__indicator-inner, .cart-count, [data-cart-count]").forEach(function (el) {
    el.style.display = "none";
    el.setAttribute("aria-hidden", "true");
    el.textContent = "";
  });
  document.querySelectorAll(".quick-cart__trigger").forEach(function (el) {
    el.setAttribute("aria-label", "CART");
    var text = el.querySelector(".cart-text");
    if (text) text.textContent = "CART";
  });

  document.documentElement.style.setProperty("--pf-lookbook-menu-height", "0px");

  /* LOOKBOOK — single page, no season submenu. */
  function flattenLookbookNav() {
    var lookbookItem =
      document.querySelector(".nav__item-id-lookbook, .nav__item-lookbook") ||
      [...document.querySelectorAll(".dette-er-nav-menyen .nav--depth-1 > .nav__item")].find(function (li) {
        var link = li.querySelector(":scope > a, :scope > .nav__link-parent");
        if (!link) return false;
        var t = (link.textContent || "").trim().toUpperCase();
        return t === "LOOKBOOK" || t === "ARCHIVE" || t.indexOf("LOOKBOOK") === 0;
      });
    if (!lookbookItem) return;

    /* Strip Location (and any leftover children) out of Lookbook before flattening */
    lookbookItem.querySelectorAll("a, .nav__link, .nav__link-parent").forEach(function (a) {
      var t = (a.textContent || "").trim().toUpperCase();
      if (t === "LOCATION" || t === "LOCATIONS" || /\/pages\/locations/i.test(a.getAttribute("href") || "")) {
        var li = a.closest("li");
        if (li && li !== lookbookItem) li.remove();
      }
    });

    var submenu = lookbookItem.querySelector(".nav__submenu, #header-sub-menu--lookbook");
    if (submenu) submenu.remove();

    var existing = lookbookItem.querySelector(":scope > a, :scope > .nav__link-parent, :scope > button");
    var link = document.createElement("a");
    link.href = "/pages/lookbook";
    link.className = "nav__link";
    link.textContent = "LOOKBOOK";
    if (existing) existing.replaceWith(link);
    else lookbookItem.appendChild(link);
    lookbookItem.classList.remove("nav__item-parent", "has-dropdown", "nav__item--active", "nav__item--current", "active", "current");
    lookbookItem.querySelectorAll("[aria-current]").forEach(function (el) {
      el.removeAttribute("aria-current");
    });
  }
  flattenLookbookNav();

  /* Footer links — direct child of <body>, pinned to the screen bottom.
     Never inside the hero/main: a transformed or fixed ancestor in there
     can trap position:fixed and let the footer drift with the page. */
  function pinDropFooter(footer) {
    /* Footer sits at the BOTTOM OF THE PAGE (in flow, last element) on
       every page — it does not float or follow the scroll. Inline
       static here so no stylesheet can re-pin it to the screen. */
    if (document.body.classList.contains("template-index")) {
      /* Homepage is one screen — footer stays on the photo */
      footer.style.setProperty("position", "fixed", "important");
      footer.style.setProperty("left", "0", "important");
      footer.style.setProperty("right", "0", "important");
      footer.style.setProperty("bottom", "0", "important");
      footer.style.setProperty("top", "auto", "important");
      footer.style.setProperty("width", "100%", "important");
      footer.style.setProperty("transform", "none", "important");
      footer.style.setProperty("-webkit-transform", "none", "important");
      footer.style.setProperty("box-sizing", "border-box", "important");
      return;
    }
    footer.style.setProperty("position", "static", "important");
    footer.style.setProperty("top", "auto", "important");
    footer.style.setProperty("bottom", "auto", "important");
    footer.style.setProperty("left", "auto", "important");
    footer.style.setProperty("right", "auto", "important");
    footer.style.setProperty("width", "100%", "important");
    footer.style.setProperty("transform", "none", "important");
    footer.style.setProperty("-webkit-transform", "none", "important");
    footer.style.setProperty("box-sizing", "border-box", "important");
  }

  function buildDropFooter() {
    var footer = document.querySelector(".drop-footer");
    if (!footer) {
      footer = document.createElement("footer");
      footer.className = "drop-footer";
      footer.innerHTML =
        '<nav class="drop-footer__nav" aria-label="Help">' +
        '<a class="drop-footer__link" href="/policies/shipping-policy">Shipping &amp; Delivery</a>' +
        '<a class="drop-footer__link" href="/policies/refund-policy">Returns</a>' +
        '<a class="drop-footer__link" href="/pages/customer-care">Customer Care</a>' +
        '<a class="drop-footer__link" href="/pages/product-care">Product Care</a>' +
        '<a class="drop-footer__link" href="/policies/privacy-policy">Privacy</a>' +
        '<a class="drop-footer__link" href="/policies/terms-of-service">Terms</a>' +
        "</nav>";
    }
    if (footer.parentNode !== document.body) document.body.appendChild(footer);
    pinDropFooter(footer);
  }
  buildDropFooter();
  window.addEventListener("load", buildDropFooter);

  /* Footer is position:static (or fixed only on home). No scroll/touch
     listeners — previous stickDropFooter rewrote styles every frame. */

  /* Nav dropdowns — The Row–style height reveal (grid 0fr → 1fr) */
  var ARROW_SVG =
    '<span class="arrow" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" focusable="false" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m6 9 6 6 6-6"/></svg></span>';

  function buildNavDropdown(item, label, links, extraClass) {
    if (!item || item.querySelector(".drop-shop-details, .drop-loc-details")) return;

    var details = document.createElement("details");
    details.className = "drop-shop-details nav__item-parent" + (extraClass ? " " + extraClass : "");

    var summary = document.createElement("summary");
    summary.className = "nav__link nav__link-parent nav__item-primary drop-shop-trigger";
    summary.innerHTML = label + ARROW_SVG;

    var shell = document.createElement("div");
    shell.className = "drop-shop-shell";

    var clip = document.createElement("div");
    clip.className = "drop-shop-clip";

    var panel = document.createElement("ul");
    panel.className = "nav__submenu drop-shop-panel";
    links.forEach(function (link) {
      var li = document.createElement("li");
      li.className = "nav__item";
      li.innerHTML = '<a class="nav__link" href="' + link.href + '">' + link.label + "</a>";
      panel.appendChild(li);
    });

    clip.appendChild(panel);
    shell.appendChild(clip);
    details.appendChild(summary);
    details.appendChild(shell);
    item.replaceChildren(details);

    summary.addEventListener("click", function (e) {
      e.stopPropagation();
      /* Only one top nav dropdown open at a time */
      document.querySelectorAll(".dette-er-nav-menyen details.drop-shop-details[open]").forEach(function (other) {
        if (other !== details) other.removeAttribute("open");
      });
    });

    document.addEventListener("click", function (e) {
      if (!details.open) return;
      if (!details.contains(e.target)) details.removeAttribute("open");
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && details.open) details.removeAttribute("open");
    });
  }

  function findTopNavItem(matchFn) {
    return [...document.querySelectorAll(".dette-er-nav-menyen .nav--depth-1:not(.nav__submenu) > .nav__item")].find(
      matchFn
    );
  }

  var shopItem =
    document.querySelector(".nav__item-store") ||
    findTopNavItem(function (li) {
      var link = li.querySelector(":scope > a, :scope > .nav__link-parent, :scope > summary");
      return link && (link.textContent || "").trim().toUpperCase().indexOf("SHOP") === 0;
    });
  buildNavDropdown(shopItem, "SHOP", SHOP_LINKS);

  /* LOCATION — plain top-level link (same treatment as LOOKBOOK) */
  function flattenLocationNav() {
    var top = document.querySelector(".dette-er-nav-menyen .nav--depth-1:not(.nav__submenu)");
    if (!top) return;

    var locationItem = findTopNavItem(function (li) {
      var t = (li.textContent || "").trim().toUpperCase();
      return t.indexOf("LOCATION") === 0;
    });

    if (!locationItem) {
      var lookbook = findTopNavItem(function (li) {
        var t = (li.textContent || "").trim().toUpperCase();
        return t.indexOf("LOOKBOOK") === 0 || t.indexOf("ARCHIVE") === 0;
      });
      locationItem = document.createElement("li");
      locationItem.className = "nav__item nav__item-location";
      if (lookbook && lookbook.nextSibling) top.insertBefore(locationItem, lookbook.nextSibling);
      else if (lookbook) top.appendChild(locationItem);
      else top.appendChild(locationItem);
    }

    var submenu = locationItem.querySelector(".nav__submenu, details, .drop-shop-details, .drop-loc-details");
    if (submenu) submenu.remove();

    var existing = locationItem.querySelector(":scope > a, :scope > .nav__link-parent, :scope > button, :scope > summary");
    var link = document.createElement("a");
    link.href = "/pages/locations";
    link.className = "nav__link";
    link.textContent = "LOCATION";
    if (existing) existing.replaceWith(link);
    else locationItem.replaceChildren(link);

    locationItem.classList.remove("nav__item-parent", "has-dropdown", "nav__item--active", "nav__item--current", "active", "current");
    locationItem.querySelectorAll("[aria-current]").forEach(function (el) {
      el.removeAttribute("aria-current");
    });
  }
  flattenLocationNav();

  /* Mobile MENU — SHOP dropdown + LOOKBOOK + LOCATION links */
  function rebuildMobileDrawer() {
    var list = document.querySelector(".drawer-menu__primary-links");
    if (!list || list.dataset.dropMobileMenu === "1") return;
    list.dataset.dropMobileMenu = "1";

    var parent = list.parentNode;
    if (!parent) return;

    var track = document.createElement("div");
    track.className = "drop-mobile-track";

    var root = document.createElement("ul");
    root.className = "drawer-menu__primary-links drop-mobile-root";
    root.innerHTML =
      '<li class="drawer-menu__item" data-list-item>' +
      '<a class="drawer-menu__link drop-mobile-shop-open" href="#shop" data-item="parent"><span>SHOP</span></a>' +
      "</li>" +
      '<li class="drawer-menu__item" data-list-item>' +
      '<a class="drawer-menu__link" href="/pages/lookbook" data-item="link"><span>LOOKBOOK</span></a>' +
      "</li>" +
      '<li class="drawer-menu__item" data-list-item>' +
      '<a class="drawer-menu__link" href="/pages/locations" data-item="link"><span>LOCATION</span></a>' +
      "</li>";

    function makePanel(extraClass, links) {
      var ul = document.createElement("ul");
      ul.className = "drawer-menu__primary-links " + extraClass;
      ul.setAttribute("aria-hidden", "true");
      ul.innerHTML =
        '<li class="drawer-menu__item" data-list-item>' +
        '<a class="drawer-menu__link drop-mobile-panel-back" href="#menu" data-item="parent"><span>BACK</span></a>' +
        "</li>";
      links.forEach(function (link) {
        ul.innerHTML +=
          '<li class="drawer-menu__item" data-list-item>' +
          '<a class="drawer-menu__link" href="' +
          link.href +
          '" data-item="link"><span>' +
          link.label +
          "</span></a></li>";
      });
      return ul;
    }

    var shop = makePanel("drop-mobile-shop", SHOP_LINKS);

    track.appendChild(root);
    track.appendChild(shop);
    parent.replaceChild(track, list);
  }
  rebuildMobileDrawer();

  function initMobileMenuToggle() {
    var drawer = document.querySelector(".drawer-menu");
    var trigger = document.querySelector("#mobile-nav, .mobile-nav__trigger");
    if (!drawer || !trigger || trigger.dataset.dropMenuBound === "1") return;
    trigger.dataset.dropMenuBound = "1";

    function isOpen() {
      return drawer.classList.contains("visible");
    }

    function setChrome(open) {
      document.documentElement.classList.toggle("pf-drawer-open", open);
      document.body.classList.toggle("pf-drawer-open", open);
    }

    function clearPanels() {
      drawer.classList.remove("drop-shop-open", "drop-loc-open");
      var shop = drawer.querySelector(".drop-mobile-shop");
      if (shop) shop.setAttribute("aria-hidden", "true");
    }

    function setShopOpen(open) {
      drawer.classList.toggle("drop-shop-open", open);
      var shop = drawer.querySelector(".drop-mobile-shop");
      if (shop) shop.setAttribute("aria-hidden", open ? "false" : "true");
      requestAnimationFrame(positionPanelUnderMenu);
    }

    function positionPanelUnderMenu() {
      var panel = drawer.querySelector(".drawer-menu__panel");
      if (!panel) return;
      var tr = trigger.getBoundingClientRect();
      panel.style.setProperty("position", "fixed", "important");
      panel.style.setProperty("top", Math.round(tr.bottom + 4) + "px", "important");
      panel.style.setProperty("left", Math.round(tr.left) + "px", "important");
      panel.style.setProperty("right", "auto", "important");
      panel.style.setProperty("transform", "none", "important");
      panel.style.setProperty("margin", "0", "important");
    }

    function openMenu() {
      clearPanels();
      drawer.classList.add("active");
      void drawer.offsetHeight;
      requestAnimationFrame(function () {
        drawer.classList.add("visible");
        setChrome(true);
        positionPanelUnderMenu();
        requestAnimationFrame(positionPanelUnderMenu);
      });
    }

    function closeMenu() {
      drawer.classList.remove("visible");
      setChrome(false);
      window.setTimeout(function () {
        if (!drawer.classList.contains("visible")) {
          drawer.classList.remove("active");
          clearPanels();
        }
      }, 620);
    }

    trigger.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (isOpen()) closeMenu();
        else openMenu();
        if (trigger.blur) trigger.blur();
      },
      true
    );

    drawer.addEventListener(
      "click",
      function (e) {
        var openShop = e.target.closest(".drop-mobile-shop-open");
        if (openShop) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          setShopOpen(true);
          return;
        }
        var backBtn = e.target.closest(".drop-mobile-panel-back, .drop-mobile-shop-back");
        if (backBtn) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          clearPanels();
        }
      },
      true
    );

    document.addEventListener("click", function (e) {
      if (!isOpen()) return;
      if (e.target.closest(".drawer-menu__panel")) return;
      if (e.target.closest("#mobile-nav, .mobile-nav__trigger, .mobile-nav")) return;
      closeMenu();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !isOpen()) return;
      if (drawer.classList.contains("drop-shop-open") || drawer.classList.contains("drop-loc-open")) clearPanels();
      else closeMenu();
    });

    window.addEventListener("resize", function () {
      if (isOpen()) positionPanelUnderMenu();
    });
    window.addEventListener("orientationchange", function () {
      if (isOpen()) setTimeout(positionPanelUnderMenu, 80);
    });
  }
  initMobileMenuToggle();

  /* Shop / collection — PF Drop View 2/3/4 column switcher */
  function initShopViewSwitcher() {
    if (!document.body.classList.contains("template-collection")) return;
    if (document.querySelector(".drop-shop-view")) return;

    var grid =
      document.querySelector(".butikk-grid") ||
      document.querySelector(".grid-display--has-products") ||
      document.querySelector(".collection__infinite-container") ||
      document.querySelector(".collection__products") ||
      document.querySelector(".product-grid") ||
      document.querySelector("[data-product-grid]");
    if (!grid) return;

    var bar = document.createElement("div");
    bar.className = "drop-shop-view";
    bar.innerHTML =
      '<span class="drop-shop-view__label">View</span>' +
      '<button type="button" class="drop-shop-view__btn" data-cols="2">2</button>' +
      '<button type="button" class="drop-shop-view__btn is-active" data-cols="3">3</button>' +
      '<button type="button" class="drop-shop-view__btn" data-cols="4">4</button>';

    /* Sit the View switcher inside the header, on LOOKBOOK's row (desktop).
       Falls back to above the grid if the header inner is missing. */
    var headerInner = document.querySelector(".header__content-inner");
    if (headerInner) headerInner.appendChild(bar);
    else grid.parentNode.insertBefore(bar, grid);

    function isMobileShop() {
      return window.matchMedia("(max-width: 60em)").matches;
    }

    var userCols = null;
    var wasMobile = isMobileShop();

    function setCols(n) {
      if (isMobileShop()) n = 2;
      document.documentElement.style.setProperty("--drop-shop-cols", String(n));
      document.body.style.setProperty("--drop-shop-cols", String(n));
      bar.querySelectorAll(".drop-shop-view__btn").forEach(function (btn) {
        btn.classList.toggle("is-active", btn.getAttribute("data-cols") === String(n));
      });
    }

    setCols(isMobileShop() ? 2 : 3);
    bar.addEventListener("click", function (e) {
      var btn = e.target.closest(".drop-shop-view__btn");
      if (!btn) return;
      userCols = btn.getAttribute("data-cols");
      setCols(userCols);
    });
    window.addEventListener("resize", function () {
      var nowMobile = isMobileShop();
      if (nowMobile === wasMobile) return;
      wasMobile = nowMobile;
      setCols(nowMobile ? 2 : userCols || 3);
    });
  }

  initShopViewSwitcher();

  /* Product page — accordion labels + desktop gallery */
  function normalizeAccordions() {
    var map = {
      description: "DESCRIPTION",
      "size guide": "SIZING",
      sizing: "SIZING",
      "shipping & returns": "SHIPPING & RETURNS",
    };
    document.querySelectorAll(".accordion__label").forEach(function (label) {
      var key = (label.textContent || "").trim().toLowerCase();
      if (map[key]) label.textContent = map[key];
    });
  }

  function initDesktopGallery() {
    if (!document.body.classList.contains("template-product")) return;
    if (!window.matchMedia("(min-width: 60em)").matches) return;

    var product = document.querySelector(".product.produkt-ting");
    if (!product) return;

    var images = product.querySelectorAll(".product__media .media-wrapper");
    if (!images.length) return;

    images.forEach(function (img, index) {
      img.classList.toggle("hidden", index !== 0);
    });

    product.querySelectorAll("[data-product-thumbnail]").forEach(function (thumb, index) {
      thumb.classList.toggle("active", index === 0);
      if (thumb.dataset.dropThumbBound) return;
      thumb.dataset.dropThumbBound = "1";
      thumb.addEventListener("click", function (e) {
        if (!window.matchMedia("(min-width: 60em)").matches) return;
        e.preventDefault();
        e.stopPropagation();
        var id = thumb.getAttribute("data-thumbnail-id");
        images.forEach(function (img) {
          img.classList.toggle("hidden", img.getAttribute("data-media-id") !== id);
        });
        product.querySelectorAll("[data-product-thumbnail]").forEach(function (t) {
          t.classList.remove("active");
        });
        thumb.classList.add("active");
      });
    });
  }

  /* Phone PDP: subtle swipe dots under the photo track */
  function initMobileSwipeGallery() {
    if (!document.body.classList.contains("template-product")) return;
    if (!window.matchMedia("(max-width: 59.99em)").matches) return;

    var product = document.querySelector(".product.produkt-ting");
    if (!product) return;

    var track = product.querySelector(".product__media");
    var container = product.querySelector(".product__media-container");
    if (!track || !container) return;

    var slides = track.querySelectorAll(".media-wrapper");
    if (slides.length < 2) return;

    /* Always start on the first gallery photo */
    var startIndex = 0;
    slides.forEach(function (slide) {
      slide.classList.remove("hidden");
    });
    requestAnimationFrame(function () {
      track.scrollLeft = 0;
    });

    if (container.querySelector(".pf-swipe-dots")) return;

    var dots = document.createElement("div");
    dots.className = "pf-swipe-dots";
    dots.setAttribute("aria-hidden", "true");

    slides.forEach(function (slide, index) {
      var dot = document.createElement("button");
      dot.type = "button";
      dot.className = "pf-swipe-dot" + (index === startIndex ? " is-active" : "");
      dot.setAttribute("aria-label", "View photo " + (index + 1));
      dot.addEventListener("click", function () {
        track.scrollTo({ left: index * track.clientWidth, behavior: "smooth" });
      });
      dots.appendChild(dot);
    });
    container.appendChild(dots);

    var ticking = false;
    track.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var active = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          dots.querySelectorAll(".pf-swipe-dot").forEach(function (dot, index) {
            dot.classList.toggle("is-active", index === active);
          });
        });
      },
      { passive: true }
    );
  }

  /* Phone Shop All: header text fades out on scroll, never sticks */
  function initCollectionHeaderFade() {
    if (!document.body.classList.contains("template-collection")) return;
    if (!window.matchMedia("(max-width: 59.99em)").matches) return;
    var ticking = false;
    function update() {
      ticking = false;
      document.documentElement.classList.toggle(
        "pf-header-faded",
        window.scrollY > 30
      );
    }
    window.addEventListener(
      "scroll",
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    update();
  }

  /* Beat theme variant init that can open a non-first photo */
  function forceFirstProductImage() {
    if (!document.body.classList.contains("template-product")) return;
    var product = document.querySelector(".product.produkt-ting");
    if (!product) return;
    var images = product.querySelectorAll(".product__media .media-wrapper");
    if (!images.length) return;
    if (window.matchMedia("(min-width: 60em)").matches) {
      images.forEach(function (img, index) {
        img.classList.toggle("hidden", index !== 0);
      });
      product.querySelectorAll("[data-product-thumbnail]").forEach(function (thumb, index) {
        thumb.classList.toggle("active", index === 0);
      });
    } else {
      var track = product.querySelector(".product__media");
      if (track) track.scrollLeft = 0;
    }
  }

  normalizeAccordions();
  initDesktopGallery();
  initMobileSwipeGallery();
  forceFirstProductImage();
  requestAnimationFrame(forceFirstProductImage);
  setTimeout(forceFirstProductImage, 120);
  initCollectionHeaderFade();

  /* Size — clear inline locks so CSS can show selected / sold-out */
  function normalizeSizeChips() {
    if (!document.body.classList.contains("template-product")) return;
    document.querySelectorAll(".product-form__chip").forEach(function (chip) {
      var t = (chip.textContent || "").replace(/\s+/g, " ").trim();
      if (chip.childNodes.length === 1 && chip.firstChild.nodeType === 3 && chip.textContent !== t) {
        chip.firstChild.textContent = t;
      }
      /* Remove inline styles that block class-based selected/sold-out UI */
      [
        "text-decoration",
        "text-decoration-line",
        "opacity",
        "color",
        "-webkit-text-fill-color",
        "border",
        "width",
        "height",
        "min-width",
        "min-height",
        "padding",
        "background",
      ].forEach(function (prop) {
        chip.style.removeProperty(prop);
      });
      chip.style.border = "";
      chip.style.width = "";
      chip.style.height = "";
    });
  }
  normalizeSizeChips();
  setTimeout(normalizeSizeChips, 300);
  document.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest(".product-form__chip")) {
      setTimeout(normalizeSizeChips, 0);
      setTimeout(normalizeSizeChips, 50);
    }
  });

  /* Space between ATC / Notify me and Shop Pay */
  function compactPaymentSpacing() {
    if (!document.body.classList.contains("template-product")) return;
    document
      .querySelectorAll(
        ".shopify-payment-button, shopify-accelerated-checkout, .additional-checkout-buttons, .product-form__payment-button"
      )
      .forEach(function (el) {
        el.style.setProperty("margin-top", "10px", "important");
        el.style.setProperty("margin-bottom", "0", "important");
        el.style.setProperty("margin-left", "0", "important");
        el.style.setProperty("margin-right", "0", "important");
      });
  }
  compactPaymentSpacing();
  setTimeout(compactPaymentSpacing, 500);
  setTimeout(compactPaymentSpacing, 1500);

  /* PDP photos: swipe/scroll only — block zoom / lightbox / product-link clicks */
  function disableProductPhotoClicks() {
    if (!document.body.classList.contains("template-product")) return;
    document.addEventListener(
      "click",
      function (e) {
        var open = e.target.closest && e.target.closest("[data-open], .product__media-action-button, a.media__image");
        if (!open) return;
        if (!open.closest(".product__media, .product__media-container, .produkt-bilde-ting")) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      },
      true
    );
    document.querySelectorAll(".product__media a.media__image, .produkt-bilde-ting a.media__image").forEach(function (a) {
      a.removeAttribute("href");
      a.style.cursor = "default";
      a.style.pointerEvents = "none";
    });
  }
  disableProductPhotoClicks();

  /* Opacity handled in CSS (drop-coor.css) — no MutationObserver / inline style thrash */

  /* Debounce gallery re-init — raw resize fires dozens of times per drag */
  var galleryResizeTimer = 0;
  window.addEventListener("resize", function () {
    clearTimeout(galleryResizeTimer);
    galleryResizeTimer = setTimeout(initDesktopGallery, 150);
  });
})();
